/* eslint-disable consistent-return */

import Component from '@bythepixel/component-loader';

export default class FavoriteCounter extends Component {
  static selector = '[data-comp-favorite-count]';

  constructor(containerEl, options) {
    super(containerEl, options);

    this.initCounter();
  }

  getCounter() {
    return document.querySelector(FavoriteCounter.selector);
  }

  initCounter() {
    const counter = this.getCounter();

    if (!counter) return;

    const count = counter.querySelector('span').textContent.trim();

    this.updateCounterValue(count);
    this.updateAriaHidden();
  }

  updateCounterValue(count) {
    const counter = this.getCounter();

    if (!counter) return;

    counter.querySelector('span').textContent = count;
    this.count = count;
  }

  updateAriaHidden() {
    this.$container.ariaHidden = this.count === 0;
  }

  get count() {
    const counter = this.getCounter();

    if (!counter) return;

    return parseInt(counter.dataset.numberOfFavorites);
  }

  set count(newCount) {
    const counter = this.getCounter();

    if (!counter) return;

    counter.dataset.numberOfFavorites = newCount;
  }
}
